import { QuoteWheelDetail } from "features/quotation/types";

/**
 * Sort wheel groups by ホイール4本合計 (wheel confirm_total_price) descending,
 * and tire rows under each wheel by 見積金額 set total (tire confirm_total_price) descending.
 * Returns a new array; does not mutate the input.
 */
export default function sortQuoteDetailWheelsForDisplay(
  wheels: QuoteWheelDetail[] | undefined,
): QuoteWheelDetail[] {
  if (!wheels?.length) return [];

  return [...wheels]
    .map((wheel) => ({
      ...wheel,
      tbl_quote_detail_tire: [...(wheel.tbl_quote_detail_tire ?? [])].sort(
        (a, b) => (b.confirm_total_price ?? 0) - (a.confirm_total_price ?? 0),
      ),
    }))
    .sort((a, b) => (b.confirm_total_price ?? 0) - (a.confirm_total_price ?? 0));
}
